import { TableFilterState } from '@ibsys/kit';
import type { SearchEntityType, SearchQueryRequest } from '@/entities/search';
import { tableFilters2Query } from '@/shared/lib';
import type { SearchQueryParams } from './types';

/**
 * Builds SearchQueryParams from committed search (for useCommittedSearch pattern).
 */
export const buildSearchQueryParams = (
  committed: {
    query: string;
    mode: SearchQueryParams['searchMode'];
  } | null,
): SearchQueryParams => {
  if (!committed) {
    return { human: '', dsl: '', searchMode: 'nl' };
  }
  return {
    human: committed.mode === 'nl' ? committed.query : '',
    dsl: committed.mode === 'dsl' ? committed.query : '',
    searchMode: committed.mode,
  };
};

/**
 * Формирует базовые поля запроса (entityType, query), общие для всех типов сущностей.
 * Сортировка обрабатывается отдельно для каждого типа сущности.
 */
export const buildBaseRequest = (
  entityType: SearchEntityType,
  query: SearchQueryParams,
): Pick<SearchQueryRequest, 'entityType' | 'dslHuman' | 'dsl'> => {
  const currentQuery = query.searchMode === 'nl' ? query.human : query.dsl;
  const trimmedQuery = currentQuery.trim();

  const base: Pick<SearchQueryRequest, 'entityType' | 'dslHuman' | 'dsl'> = {
    entityType,
  };

  if (trimmedQuery) {
    if (query.searchMode === 'nl') {
      base.dslHuman = trimmedQuery;
    } else {
      base.dsl = trimmedQuery;
    }
  }

  return base;
};

/**
 * Условия отбора сущности, чьи фильтры списка уходят в запрос без преобразований: id колонки —
 * имя условия, значение фильтра — его значение. Состав условий задаёт тип `T` сущности;
 * без единого условия результата нет, и `filters` в запрос не попадает.
 */
export const buildPlainFilters = <T extends object>(filters: TableFilterState): T | undefined => {
  const searchFilters = tableFilters2Query(filters);
  return Object.keys(searchFilters).length > 0 ? (searchFilters as T) : undefined;
};
